import { loadI18nLanguageEngineAsync } from '@i18n';

const state = {
  inited: false,
  general: {
    editorTheme: undefined, // light, dark
    languageEngine: undefined,
  },
  permissions: {
    fileManager: {
      folder: {
        view: true,
        add: (process.env.VUE_APP_ENV_NAME == 'template') ? false : true,
        edit: true,
        delete: true,
      },
    },
  },
  adminType: '',
}

const getters = {
  inited: state => {
    return state.inited;
  },
  general: state => {
    return state.general;
  },
  languageEngine: state => {
    return state.general.languageEngine;
  },
  permissions: state => {
    return state.permissions;
  },
  adminType: state => {
    return state.adminType;
  },
}

const mutations = {
  SET_INITED(state) {
    state.inited = true;
  },
  SET_GENERAL(state, { configs }) {
    state.general = configs
  },
  SET_EDITOR_THEME(state, { editorTheme }) {
    state.general.editorTheme = editorTheme
  },
  SET_LANGUAGE_ENGINE(state, { language }) {
    state.general.languageEngine = language
  },
  SET_ADMIN_TYPE(state, { adminType }){
    state.adminType = adminType;
  },
}

const actions = {
  syncInit({ dispatch, state }) {
    dispatch('designIframe/userPreference/init', { configs: state.general }, { root: true })
  },

  init: async ({ dispatch, commit }, { configs }) => {
    commit('SET_EDITOR_THEME', { editorTheme: configs.editorTheme });
    commit('SET_ADMIN_TYPE', { adminType: configs.adminRoleSystemType });
    await dispatch('setLanguageEngine', { language: configs.languageEngine });
    commit('SET_INITED');
  },
  async setLanguageEngine({ commit }, { language }) {
    await loadI18nLanguageEngineAsync(language);
    commit('SET_LANGUAGE_ENGINE', { language })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};